import { toast } from "react-toastify";

const CustomToast = ({ type, message }) => {
    console.log(type, message)
  toast[type](<p style={{ fontSize: 16 }}>{message}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "fullscreen-toast",
  });
};

export default CustomToast;
